// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2a6m9","item":"PaymentsMobile_item__1UCvN","label":"PaymentsMobile_label__TQATz","amount":"PaymentsMobile_amount__20fdD"};